import React from 'react';
import {i18n} from 'core/localization';
import {Utils} from "tools/utils";
import {Settings} from "settings";
import {Cookies} from "core";
import {CustomNotification, ExpandableTextarea, Tags} from "controls";
import { AntSelect } from "controls/react/ant/ant-select/antSelect";
import FormEntry from "controls/react/form/formEntry";
import {TagsSelect} from "controls/react/tagsSelect";
import { ActionTriggerSwitcher } from './users/components/action-trigger-switcher/actionTriggerSwitcher';
import {createRoot} from 'react-dom/client';
import { fieldNamesIdName } from 'controls/react/ant/ant-select/types';

export let TeamProfileView = function (config) {
	Utils.apply(this, config);
	this._events = [];
	this.initComponent();
};

jQuery.extend(TeamProfileView.prototype, kendo.Observable.prototype, {
	initialNameValue: '',

	nameIsDirty() {
		return this.initialNameValue != $('#team_name').val();
	},
	/**
	 * This is main init function
	 */
	initComponent: function () {
		this.update = true;
		this.tagsDataSource = [];
		if (this.mode === 'view') {
			this.update = false;
		}
		this.usersLoaded = false;
		this.dataLoaded = false;
		this.descriptionHandler = new ExpandableTextarea({
			renderTo: $('.cw_team_summary .cw_description')
		});

		this.statusNotification = new CustomNotification({
			appendToElement: '.window_area',
			style: 'top:15px; right:15px; left:15px;',
			status: 'success',
			type: 'icon',
			hideOnClick: true
		});

		if (this.mode === 'update' || this.mode === 'view') {
			this.load();
		} else {
			var focus = function () {
				$('#team_name').focus();
			};
			setTimeout(focus, 1000);
			this.renderTags();
		}
		this.loadUsers();
		const actionTrigger = $('<div id="user_details__action_trigger" class="cw_field"></div>')
		$('.cw_team_summary .form .cw_user_panel').append(actionTrigger);
		if (this.mode === 'view' || !State.mainApp.session.hasRole("TEAM_UPDATE")) {
			$('#team_name').addClass('is_readonly');
			$('#save_team').attr('disabled', true);
			$('.is_readonly').attr('disabled', true);
			this.descriptionHandler.readonly(true);
		}
		this.actionTriggerRoot = createRoot(actionTrigger[0]);
		this.actionTriggerRoot.render(<ActionTriggerSwitcher type={"teams"} id={this.id} disabled={this.mode !== 'update' || !State.mainApp.session.hasRole("TEAM_UPDATE")}/>);

	},
	renderTags() {
		this.tagsRoot = createRoot($('.cw_team_tags').parent().get()[0]);
		this.tagsRoot.render(<FormEntry label={i18n('Tags')} vertical={true}>
			<TagsSelect
				mode={'tags'}
				disabled={this.mode === 'view' || !State.mainApp.session.hasRole("TEAM_UPDATE")}
				accountId={Cookies.CeesoftCurrentAccountId}
				includeSubaccounts={false}
				onChange={value => this.onTagsChange(value)}
				defaultValue={this.tags}
				placeholder={i18n('Choose a tag...')} />
		</FormEntry>);
	},
	onTagsChange(value) {
		this.tags = value || [];
	},
	/**
	 * Loads users into dropdown multi select control
	 */
	loadUsers: function () {
		var url = Settings.serverPath + 'accounts/' + Cookies.CeesoftCurrentAccountId + '/users/lite';
		Utils.ajax(url, 'GET', {}, $.proxy(function (result) {
			var users = result;
			for (let user of users) {
				user.name = user.username;
			}
			this.usersMultiSelRoot = createRoot($('#users_multi_select').parent().get()[0])
			this.usersMultiSelRoot.render(<FormEntry label={i18n('Select users')} vertical style={{maxWidth: '100%'}}>
				<AntSelect
					options={users}
					mode={"multiple"}
					sortValues={true}
					fieldNames={fieldNamesIdName}
					onChange={value => this.onUsersChange(value)}
					defaultValue={this.usersList}
					disabled={this.mode === 'view' || !State.mainApp.session.hasRole("TEAM_UPDATE")}
					placeholder={i18n('Select...')} />
			</FormEntry>);
			this.usersLoaded = true;
		}, this));
	},
	onUsersChange: function(value) {
		this.usersList = value;
	},
	/**
	 * Removes the invalid CSS class for all controls
	 */
	clearInvalid: function () {
		$('#team_name').removeClass('invalid');
	},
	/**
	 * Loads the form data from the server and set the values into component fields
	 */
	load: function () {
		var loadUrl = Settings.serverPath + 'accounts/' + Cookies.CeesoftCurrentAccountId + '/teams/' + this.id + '/?update=' + this.update;
		Utils.ajax(loadUrl, 'GET', {}, $.proxy(function (result) {
			if (result.success) {
				this.descriptionHandler.value(result.data.description);
				this.initialNameValue = result.data.name;
				$('#team_name').val(result.data.name).focus();
				$('#cw_cvid').val(result.data.id);
				this.dataLoaded = true;
				this.usersList = result.data.members;
				this.trigger('dataload', result.data);
				this.tags = result.data.tags;
				this.renderTags();
			} else {
				Utils.showInfo(i18n('Alert'), result.message, result.details);
			}
		}, this));
	},
	/*
	* Handler function for collecting the data for saving
	* */
	collectData: function () {
		var data = {
			name: $('#team_name').val().trim(),
			description: this.descriptionHandler.value().trim(),
			id: this.id ? this.id : null,
			members: this.usersList || [],
			tags: this.tags
		};
		return data;
	},

	destroy: function () {
		this.tagsRoot?.unmount();
		this.actionTriggerRoot?.unmount();
		this.usersMultiSelRoot?.unmount();
	}
});


